import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { FilterDTO, SortDirection, VendorScoreCardClient, VendorScoreCardOverviewExtendedDTO } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class VendorScoreCardVendorsDataService extends ShowInactiveService implements IAdaptorService {

  private vendorName: string;
  private totalPoints: number;

constructor(
  private vendorScoreCardClient : VendorScoreCardClient,
  public toastService: ToastService
) {
  super();
}
  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    var id = Number.parseInt(filters[0].value);

    return this.vendorScoreCardClient.getAllVendorScoreCardVendorDataByCardId(id)
      .pipe(
        map((dto: VendorScoreCardOverviewExtendedDTO) => {
          this.vendorName = dto.vendorName;
          this.totalPoints = dto.totalPoints;
          return { items: dto.vendorDataRows, totalNumberOfItems: dto.vendorDataRows.length };
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
  
  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public getVendorName(): string {
    return this.vendorName;
  }

  public getTotalPoints(): number {
    return this.totalPoints;
  }
}
